/** Per-chart date filter keys on /csrp/admin-dashboard (matches approver-dashboard pattern). */
export const ADMIN_KPI_WIDGET_KEY = "kpi";

/** Per-chart date filter keys on /csrp/admin-dashboard (matches approver-dashboard pattern). */
export const ADMIN_CHART_DATE_KEYS = [  "openVsClosed",
  "sla",
  "category",
  "zone",
  "bv",
  "repeat",
  "settlement",
  "maxQueries",
  "country",
  "pendingSettlement",
  "reopened",
];

export const createAdminChartCardDates = (fy) => {
  const card = {
    dateRange: fy.dateRange,
    dateRangeStart: fy.dateRangeStart,
    dateRangeEnd: fy.dateRangeEnd,
  };
  return Object.fromEntries(ADMIN_CHART_DATE_KEYS.map((k) => [k, { ...card }]));
};

export const ADMIN_DASHBOARD_WIDGET_KEYS = [
  ADMIN_KPI_WIDGET_KEY,
  ...ADMIN_CHART_DATE_KEYS,
];

export const createAdminWidgetLoadingState = (initial = false) =>
  Object.fromEntries(ADMIN_DASHBOARD_WIDGET_KEYS.map((k) => [k, initial]));

export const createAdminChartDatePickerRefs = () => {
  const refs = Object.fromEntries(ADMIN_CHART_DATE_KEYS.map((k) => [k, { current: null }]));
  refs.zoneAvgTat = { current: null };
  return refs;
};